import { render, staticRenderFns } from "./CoursePeriod.vue?vue&type=template&id=370e1a3d&scoped=true&"
import script from "./CoursePeriod.vue?vue&type=script&lang=js&"
export * from "./CoursePeriod.vue?vue&type=script&lang=js&"
import style0 from "./CoursePeriod.vue?vue&type=style&index=0&id=370e1a3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370e1a3d",
  null
  
)

export default component.exports